import { render, staticRenderFns } from "./recognize_list.vue?vue&type=template&id=cda91740&scoped=true"
import script from "./recognize_list.vue?vue&type=script&lang=js"
export * from "./recognize_list.vue?vue&type=script&lang=js"
import style0 from "./recognize_list.vue?vue&type=style&index=0&id=cda91740&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda91740",
  null
  
)

export default component.exports